'use server'

import { apiRequest, ApiResponse } from '../request'

/** Quando o atendimento fecha sozinho. */
export type ChatAutoCloseMode = 'WINDOW' | 'HOURS' | 'NEVER'

export interface MessagingConfig {
    organizationId: number
    chatAutoCloseMode: ChatAutoCloseMode
    chatAutoCloseHours: number | null
    /**
     * Minutos que o contato espera sem resposta, numa conversa com a IA pausada, antes de
     * a IA entrar. `null` mantém a IA pausada até alguém liberar — é o padrão.
     */
    aiResumeAfterMinutes: number | null
    /** Horas sem mensagem de ninguém para a conversa contar como parada. `null` = sem regra. */
    aiResumeIdleHours: number | null
}

export async function getMessagingConfig(): Promise<ApiResponse<MessagingConfig>> {
    return apiRequest<MessagingConfig>('messaging/config', {})
}

export async function updateMessagingConfig(data: {
    chatAutoCloseMode: ChatAutoCloseMode
    chatAutoCloseHours?: number | null
    /** `0` e `null` significam a mesma coisa: a IA não volta sozinha. */
    aiResumeAfterMinutes?: number | null
    /** `0` e `null` desligam a regra de conversa parada. */
    aiResumeIdleHours?: number | null
}): Promise<ApiResponse<MessagingConfig>> {
    return apiRequest<MessagingConfig>('messaging/config', { data }, 'put')
}
